import React, { Fragment } from 'react';
import './ClickableZone.scss';

interface IClickableZoneProps {
    onClick: () => void;
    children: any;
    active: boolean;
}

/**
 *
 * @param onClick () => void - function to handle on click behavior in parent
 * @param childern any - child component or text to render in body
 * @param active: boolean - hides the clickablezone when false
 * @returns React.Component
 */
const ClickableZone = (props: IClickableZoneProps) => {
    return (
        <>
            {
                props.active ? (
                    <div onClick={props.onClick} className="clickable-zone">
                        {props.children}
                    </div>
                ) : props.children
            }
        </>
    )
}

export default ClickableZone;